// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import store from './store/store';
import * as baseUrl from './http/baseUrl';
import router from './router';
import '@/http/http.js';
import common from '@/common/js/common.js';
import 'jquery';
import 'muse-ui/lib/styles/base.less';
import { Button, DateInput, Picker } from 'muse-ui';
import 'muse-ui/lib/styles/theme.less';
import vant from 'vant';
import 'vant/lib/index.css';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

NProgress.configure({
  easing: 'ease', // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化时的最小百分比
});
// 当路由进入前
router.beforeEach((to, from, next) => {
  // 每次切换页面时，调用进度条
  NProgress.start();
  // 这个一定要加，没有next()页面不会跳转的。这部分还不清楚的去翻一下官网就明白了
  next();
});
// 当路由进入后：关闭进度条
router.afterEach(() => {
  // 在即将进入新的页面组件前，关闭掉进度条
  NProgress.done();
});

Vue.use(vant);
Vue.use(Button);
Vue.use(DateInput);
Vue.use(Picker);
Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.prototype.$common = common;
Vue.prototype.$baseUrl = baseUrl;

store.commit('setFoldMenu', localStorage.getItem('foldMenu') === 'true' ? Boolean('true') : false);
// 权限设置
Vue.prototype.$checkPermission = function (str) {
  let result = false;
  if (store.state.permissionList.length > 0) {
    let arr = store.state.permissionList;
    let fn = (arr) => {
      arr.forEach(e => {
        if (e.routeName === router.history.current.name) {
          /**
           * 按钮权限有  （  新增 Add    编辑 Edit   删除 Delete  权限 Power  按钮设置 BtnSet  导入 Import    导出 Export   批量打标 BatchM   关联接口 Relation     修改状态 State   打标 Mark   操作日志 Oplog  查看详情 Detail
           * 生成密钥 GenerateK 批量通过 Adopt 批量不通过 Fail）
           * **/
          if (e.buts && e.buts.length > 0) {
            e.buts.forEach(b => {
              if (b.perms === str) {
                result = true;
              }
            });
          }
        }
        if (e.children && e.children.length > 0) {
          fn(e.children);
        }
      });
    };
    fn(arr);
  }
  return result;
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js